import React from 'react';

import awardIcon from '../assets/award.png';
import RemoveButton from './options/RemoveButton';

export default function Awards({
	subTitle,
	title,
	description,
	state = false,
	handleRemove,
}) {
	return (
		<div className='award-wrap'>
			{state && <RemoveButton handleRemoveState={handleRemove} />}
			<div className={`award ys-classic`}>
				<div className='top'>
					<div className='lines'>
						<div className='line1'></div>
						<div className='line2'></div>
						<div className='line3'></div>
					</div>
					<div className='award-icon'>
						<img src={awardIcon} alt='' />
					</div>
				</div>
				<div className='bottom'>
					<div className='title'>{title}</div>
					<div className='description'>{subTitle}</div>
					<div className='description2'>{description}</div>
				</div>
			</div>
		</div>
	);
}
